import type { ApiError } from '../../gateways/api'
import { StyledAlert } from '../../theme/components/StyledAlert'
import type { Styles } from '../../theme/types/Styles'

export { StyledError }

type Props = {
  error: any
  sx?: Styles
}

const isApiError = (error: any): error is ApiError => {
  return error && typeof error.message === 'string' && 'messageDetail' in error
}

const StyledError = ({ error, sx }: Props) => {
  if (!error) {
    return null
  }

  return (
    <StyledAlert severity="error" title={error.message} sx={sx}>
      {isApiError(error)
        ? error.messageDetail
        : 'Er is een onbekende fout opgetreden.'}
    </StyledAlert>
  )
}
